export default "__VITE_ASSET__DxD5mGY9__"